<template>
  <v-container fluid>
    <template>
      <v-dialog fullscreen v-model="loading">
        <v-container fill-height fluid style="background-color: rgba(200, 200, 200, 0.5);">
          <v-layout align-center="true" justify-center="true">
            <v-progress-circular
                :on-cancel="onCancel"
                :size="70"
                color="#009688"
                indeterminate>
            </v-progress-circular>
          </v-layout>
        </v-container>
      </v-dialog>
      <modal :adaptive=true
             :clickToClose="false"
             :draggable=false
             :resizable=false
             height="auto"
             name="modal-fade-planing-presence">
        <v-card>
          <v-toolbar
              color="primary"
              dark
              flat>
            <h2 style="color:whitesmoke">Présence - {{ editedItem.firstName }} {{ editedItem.lastName }}</h2>
            <v-spacer></v-spacer>
            <v-btn
                @click="hidePresence()"
                dark
                fab
                small>
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar>
          <v-card-text>
            <v-alert :color=AlertColorS(typeS)
                     :dismissible=true
                     @input="dismissible_closeS"
                     :value=true
                     border="top"
                     class="pre-formatted multi-line"
                     colored-border
                     elevation="2"
                     icon="check_circle"
                     v-if="typeS">
              <span>{{ textS }}</span>
            </v-alert>
            <v-container>
              <v-row class="justify-center align-center">
                <h2 style="color:#01579B">{{ pointage }}</h2>
              </v-row>
              <br/>
              <br/>
              <v-row class="justify-center align-center">
                <v-col cols="12" md="6" sm="6">
                  <v-text-field :id="dynamicID()" class="centered-input align-center"
                                color="#01579B"
                                label="Matricule"
                                prepend-inner-icon="mdi-human-male"
                                readonly
                                v-model="editedItem.userId">
                  </v-text-field>
                </v-col>
                <v-col cols="12" md="6" sm="6">
                  <v-select :items="shifts"
                            @change="loadDateTimeShift"
                            class="centered-input align-center text-center" color="#01579B"
                            item-text="type"
                            item-value="type"
                            label="Shifts"
                            prepend-inner-icon="mdi-selection-ellipse-arrow-inside"
                            v-model="editedItem.shiftName">
                    <template v-slot:selection="{ item }">
                                          <span class="d-flex justify-center" style="width: 100%;">
                                            {{ item }}
                                          </span>
                    </template>
                  </v-select>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" md="6" sm="6">
                  <v-menu
                      :close-on-content-click="false"
                      :nudge-right="40"
                      min-width="290px"
                      offset-y
                      transition="scale-transition"
                      v-model="menu1"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field :id="dynamicID()"
                                    class="centered-input align-center"
                                    label="Date début Shift"
                                    persistent-hint
                                    prepend-inner-icon="mdi-calendar"
                                    readonly
                                    v-bind="attrs"
                                    v-model="computedDateFormatted1"
                                    v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                        :allowed-dates="allowedDates"
                        :disabled="isdisabled"
                        :events="functionEvents"
                        @change="loadEndDateShift(false)"
                        @input="menu1= false"
                        locale="fr-FR"
                        show-current
                        v-model="editedItem.startDate"
                    ></v-date-picker>
                  </v-menu>
                </v-col>
                <v-col cols="12" md="6" sm="6">
                  <v-dialog
                      :return-value.sync="editedItem.startTime"
                      persistent
                      ref="dialog"
                      v-model="modal2"
                      width="290px"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field :id="dynamicID()"
                                    class="centered-input align-center"
                                    disabled
                                    label="Heure début Shift"
                                    prepend-inner-icon="access_time"
                                    v-bind="attrs"
                                    v-model="computedDateFormatted11"
                                    v-on="on"
                      ></v-text-field>
                    </template>
                    <v-time-picker
                        :useSeconds=true
                        disabled
                        format="24hr"
                        full-width
                        v-if="modal2"
                        v-model="editedItem.startTime"
                    >
                      <v-spacer></v-spacer>
                      <v-btn @click="modal2 = false" color="primary" text>
                        Annuler
                      </v-btn>
                      <v-btn @click="$refs.dialog.save(editedItem.startTime)"
                             color="primary" text>Valider
                      </v-btn>
                    </v-time-picker>
                  </v-dialog>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" md="6" sm="6">
                  <v-menu
                      :close-on-content-click="false"
                      :nudge-right="40"
                      min-width="290px"
                      offset-y
                      transition="scale-transition"
                      v-model="menu2"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field :id="dynamicID()"
                                    class="centered-input align-center"
                                    disabled
                                    label="Date fin Shift"
                                    persistent-hint
                                    prepend-inner-icon="mdi-calendar"
                                    v-bind="attrs"
                                    v-model="computedDateFormatted2"
                                    v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                        @input="menu2= false"
                        disabled
                        locale="fr-FR"
                        v-model="editedItem.endDate"
                    ></v-date-picker>
                  </v-menu>
                </v-col>
                <v-col cols="12" md="6" sm="6">
                  <v-dialog
                      :return-value.sync="editedItem.endTime"
                      persistent
                      ref="dialog3"
                      v-model="modal3"
                      width="290px"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field :id="dynamicID()"
                                    class="centered-input align-center"
                                    disabled
                                    label="Heure fin Shift"
                                    prepend-inner-icon="access_time"
                                    v-bind="attrs"
                                    v-model="computedDateFormatted22"
                                    v-on="on"
                      ></v-text-field>
                    </template>
                    <v-time-picker
                        :useSeconds=true
                        disabled
                        format="24hr"
                        full-width
                        v-if="modal3"
                        v-model="editedItem.endTime"
                    >
                      <v-spacer></v-spacer>
                      <v-btn @click="modal3 = false" color="primary" text>
                        Annuler
                      </v-btn>
                      <v-btn @click="$refs.dialog3.save(editedItem.endTime)"
                             color="primary" text>Valider
                      </v-btn>
                    </v-time-picker>
                  </v-dialog>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" md="12" sm="12">
                  <v-text-field :id="dynamicID()"
                                class="centered-input align-center"
                                color="#01579B" label="Observations"
                                prepend-inner-icon="mdi-comment-edit-outline"
                                rows="1"
                                textarea
                                v-model="editedItem.presenceObservations"
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn :disabled="!FormIsValid && !loading" @click="creer"
                   class="white--text"
                   color="#01579B" depressed>Créer présence
            </v-btn>
          </v-card-actions>
        </v-card>
      </modal>
      <modal :adaptive=true
             :clickToClose="false"
             :draggable=true
             :resizable=true
             height="auto"
             name="modal-fade-heures-supp">
        <v-card>
          <v-toolbar
              color="primary"
              dark
              flat>
            <h2 style="color:whitesmoke">Heures Supp - {{ editedItem.firstName }} {{ editedItem.lastName }}</h2>
            <v-spacer></v-spacer>
            <v-btn
                @click="hideHeuresSupp()"
                dark
                fab
                small>
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar>
          <v-card-text>
            <v-alert :color=AlertColorS(typeS)
                     :dismissible=true
                     @input="dismissible_closeS"
                     :value=true
                     border="top"
                     class="pre-formatted multi-line"
                     colored-border
                     elevation="2"
                     icon="check_circle"
                     v-if="typeS">
              <span>{{ textS }}</span>
            </v-alert>
            <v-container>
              <v-row class="justify-center align-center">
                <h2 style="color:#01579B">{{ pointage }}</h2>
              </v-row>
              <br/>
              <br/>
              <v-row class="justify-center align-center">
                <v-col cols="12" md="6" sm="6">
                  <v-text-field :id="dynamicID()" class="centered-input align-center"
                                color="#01579B"
                                label="Matricule"
                                prepend-inner-icon="mdi-human-male"
                                readonly
                                v-model="editedItem.userId">
                  </v-text-field>
                </v-col>
                <v-col cols="12" md="6" sm="6">
                  <v-select :items="shifts"
                            @change="loadDateTimeShift"
                            class="centered-input align-center text-center" color="#01579B"
                            item-text="type"
                            item-value="type"
                            label="Shifts"
                            prepend-inner-icon="mdi-selection-ellipse-arrow-inside"
                            v-model="editedItem.shiftName">
                    <template v-slot:selection="{ item }">
                                              <span class="d-flex justify-center" style="width: 100%;">
                                                {{ item }}
                                              </span>
                    </template>
                  </v-select>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" md="6" sm="6">
                  <v-menu
                      :close-on-content-click="false"
                      :nudge-right="40"
                      min-width="290px"
                      offset-y
                      transition="scale-transition"
                      v-model="menu1"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field :id="dynamicID()"
                                    class="centered-input align-center"
                                    label="Date début Shift"
                                    persistent-hint
                                    prepend-inner-icon="mdi-calendar"
                                    readonly
                                    v-bind="attrs"
                                    v-model="computedDateFormatted1"
                                    v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                        :allowed-dates="allowedDates"
                        :disabled="isdisabled"
                        :events="functionEvents"
                        @change="loadEndDateShift(true)"
                        @input="menu1= false"
                        locale="fr-FR"
                        show-current
                        v-model="editedItem.startDate"
                    ></v-date-picker>
                  </v-menu>
                </v-col>
                <v-col cols="12" md="6" sm="6">
                  <v-dialog
                      :return-value.sync="editedItem.startTime"
                      persistent
                      ref="dialog"
                      v-model="modal2"
                      width="290px"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field :id="dynamicID()"
                                    class="centered-input align-center"
                                    disabled
                                    label="Heure début Shift"
                                    prepend-inner-icon="access_time"
                                    v-bind="attrs"
                                    v-model="computedDateFormatted11"
                                    v-on="on"
                      ></v-text-field>
                    </template>
                    <v-time-picker
                        :useSeconds=true
                        disabled
                        format="24hr"
                        full-width
                        v-if="modal2"
                        v-model="editedItem.startTime"
                    >
                      <v-spacer></v-spacer>
                      <v-btn @click="modal2 = false" color="primary" text>
                        Annuler
                      </v-btn>
                      <v-btn @click="$refs.dialog.save(editedItem.startTime)"
                             color="primary" text>Valider
                      </v-btn>
                    </v-time-picker>
                  </v-dialog>
                </v-col>
              </v-row>
              <v-row>
                <v-col cols="12" md="6" sm="6">
                  <v-menu
                      :close-on-content-click="false"
                      :nudge-right="40"
                      min-width="290px"
                      offset-y
                      transition="scale-transition"
                      v-model="menu2"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field :id="dynamicID()"
                                    class="centered-input align-center"
                                    disabled
                                    label="Date fin Shift"
                                    persistent-hint
                                    prepend-inner-icon="mdi-calendar"
                                    v-bind="attrs"
                                    v-model="computedDateFormatted2"
                                    v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                        @input="menu2= false"
                        disabled
                        locale="fr-FR"
                        v-model="editedItem.endDate"
                    ></v-date-picker>
                  </v-menu>
                </v-col>
                <v-col cols="12" md="6" sm="6">
                  <v-dialog
                      :return-value.sync="editedItem.endTime"
                      persistent
                      ref="dialog3"
                      v-model="modal3"
                      width="290px"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field :id="dynamicID()"
                                    class="centered-input align-center"
                                    disabled
                                    label="Heure fin Shift"
                                    prepend-inner-icon="access_time"
                                    v-bind="attrs"
                                    v-model="computedDateFormatted22"
                                    v-on="on"
                      ></v-text-field>
                    </template>
                    <v-time-picker
                        :useSeconds=true
                        disabled
                        format="24hr"
                        full-width
                        v-if="modal3"
                        v-model="editedItem.endTime"
                    >
                      <v-spacer></v-spacer>
                      <v-btn @click="modal3 = false" color="primary" text>
                        Annuler
                      </v-btn>
                      <v-btn @click="$refs.dialog3.save(editedItem.endTime)"
                             color="primary" text>Valider
                      </v-btn>
                    </v-time-picker>
                  </v-dialog>
                </v-col>
              </v-row>
              <v-row class="justify-center align-center">
                <h2 style="color:orangered">{{ heuresSup }}</h2>
              </v-row>
              <v-row>
                <v-col cols="12" md="12" sm="12">
                  <v-text-field :id="dynamicID()"
                                class="centered-input align-center"
                                color="#01579B" label="Observations"
                                prepend-inner-icon="mdi-comment-edit-outline"
                                rows="1"
                                textarea
                                v-model="editedItem.presenceObservations"
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn :disabled="!FormIsValidS && !loading" @click="creerHS"
                   class="white--text"
                   color="#01579B" depressed>Créer heures supp
            </v-btn>
          </v-card-actions>
        </v-card>
      </modal>
    </template>
    <v-card>
      <v-toolbar dense style="background:#F5F5F5">
        <v-toolbar-title dense style="color:#607D8B;font-weight:bold">Présences non planifiées
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn @click="refresh" icon>
          <v-icon color="#009688" large>mdi-refresh</v-icon>
          <template v-slot:loader>
            <span class="custom-loader"> <v-icon light>cached</v-icon></span>
          </template>
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <v-dialog fullscreen v-model="loading">
          <v-container fill-height fluid style="background-color: rgba(200, 200, 200, 0.5);">
            <v-layout align-center="true" justify-center="true">
              <v-progress-circular
                  :on-cancel="onCancel"
                  :size="70"
                  color="#009688"
                  indeterminate>
              </v-progress-circular>
            </v-layout>
          </v-container>
        </v-dialog>
        <v-alert :color=AlertColor(type)
                 :dismissible=true
                 :value=true
                 @input="dismissible_close"
                 border="top"
                 class="pre-formatted multi-line"
                 colored-border
                 elevation="2"
                 icon="check_circle"
                 style="color: #546E7A"
                 v-if="type">
          {{ text }}
        </v-alert>
        <v-card class="mt-1" flat
                tile>
          <v-row>
            <v-col>
              <v-select :items="selectDates" @change="depthDate" dense filled full-width
                        hide-details="true" item-text="name"
                        item-value="value" return-object solo style="z-index: 200"
                        v-model="depthVal">
                <template v-slot:selection="{ item }">
                                      <span class="d-flex justify-center" style="width: 100%;">
                                        {{ item.name }}
                                      </span>
                </template>
              </v-select>
            </v-col>
            <v-col v-if="isMobile===false">
              <v-spacer></v-spacer>
            </v-col>
            <v-col>
              <v-text-field :id="dynamicID()"
                            @change="search"
                            @click:clear="cleared()"
                            @keyup.native.enter="search"
                            append-icon="mdi-magnify"
                            class="centered-input align-center"
                            clearable
                            hide-details
                            placeholder="Recherche"
                            v-model="searchName">
              </v-text-field>
            </v-col>
            <v-col v-if="isMobile===false">
              <v-spacer></v-spacer>
            </v-col>
            <v-col v-if="isMobile===false">
              <v-spacer></v-spacer>
            </v-col>
            <v-col>
              <v-btn @click="onexport" block class="custom-btn white--text" color="#00BCD4" height="45px"
                     large>
                <v-icon class="mr-1">mdi-file-excel-outline</v-icon>
                <span>Export rapport</span>
              </v-btn>
            </v-col>
          </v-row>
        </v-card>
        <v-card class="mt-4"
                elevation="6">
          <hot-table :settings="hotSettings" ref="hotTable"></hot-table>
        </v-card>
      </v-card-text>
    </v-card>
  </v-container>
</template>
<script>
import {HotTable} from "@handsontable/vue";
import "handsontable/languages/fr-FR";
import apiClient from "../../../config/api.js";
import moment from "moment"
import "vue-loading-overlay/dist/vue-loading.css";
import {depthDate} from "../../../helper/profondeur";
import * as XLSX from 'xlsx';
import Handsontable from "handsontable";

function cellRenderer(hotInstance, td, row, column, prop, value, cellProperties) {
  Handsontable.renderers.TextRenderer.apply(this, arguments);
  td.className = "colPlannified";
}

function isMobileDevice() {
  return /Mobi|Android/i.test(navigator.userAgent);
}

export default {
  name: "PresencesNonPlanifiees",
  components: {HotTable},
  data: function () {
    return {
      isMobile: isMobileDevice(),
      disableMainBtn: false,
      searchName: "",
      pointage: "",
      pointageDay: "",
      pointageHour: "",
      lastHighlitedRow: null,
      isdisabled: true,
      type: null,
      typeS: null,
      typeHS: null,
      elapse: null,
      elapseS: null,
      menu1: null,
      menu2: null,
      menuHS: null,
      modal2: false,
      modal3: false,
      modalHS: false,
      loading: false,
      startDate: "",
      selectDates: depthDate,
      depthVal: {
        name: sessionStorage.getItem("depthValChoosedt"),
        value: sessionStorage.getItem("depthValChoosedd")
      },
      errors: [],
      errorsS: [],
      alert: "",
      alertS: "",
      fullPage: false,
      text: "",
      textS: "",
      textHS: "",
      color: "",
      colorS: "",
      toObject: [],
      toObjectNoHeader: [],
      heuresSup: "",
      bDisplayCreerHSBtn: false,
      shifts: [],
      shiftsFull: [],
      editedItem: {
        id: "",
        userId: "",
        firstName: "",
        lastName: "",
        shiftName: "",
        startDate: "",
        startTime: "",
        endDate: "",
        endTime: "",
        presenceObservations: ""
      },
      hotSettings: {
        renderAllRows: false,          // Rendu virtuel
        viewportRowRenderingOffset: 'auto',  // Calcul dynamique
        data: [],
        colWidths: 100,
        width: "100%",
        height: "675px",
        fixedRowsTop: 0,
        columnSorting: true,
        sortIndicator: true,
        filters: true,
        dropdownMenu: ["filter_by_condition", "filter_action_bar", "filter_operators", "filter_by_value"],
        licenseKey: "non-commercial-and-evaluation",
        stretchH: "all",
        selectionMode: "single",
        minSpareRows: false,
        contextMenu: {
          items: {
            planning_presence: {
              name: "Planning Présence",
              callback(key, selection, clickEvent) { // Callback for specific option
                setTimeout(() => {
                  let start = selection[0].start
                  window.planning_presence(start.row)
                  window.showPresence()
                }, 0);
              }
            },
            sp1: '---------',
            heures_supp: {
              name: "Heures supplémentaires",
              callback(key, selection, clickEvent) { // Callback for specific option
                setTimeout(() => {
                  let start = selection[0].start
                  window.heures_supp(start.row)
                  window.showHeuresSupp()
                }, 0);
              }
            }
          }
        },
        language: "fr-FR",
        customBorders: true,
        columnHeaders: true,
        rowHeaders: true,
        stretch: "all",
        className: "htCenter htMiddle",
        hiddenColumns: {
          columns: [0],
          indicators: false
        },
        manualColumnResize: true,
        readOnly: true,
        afterFilter: this.afterFilter,
        afterLoadData: this.afterLoadData,
        currentRowClassName: 'rowHighlight',
        colHeaders: [
          "Id", "Matricule", "Nom", "Prénom", "Brigade", "Date pointage", "Heure pointage", "Origine pointage", "Date de création", "Matricule créateur"
        ],
        columns: [
          {title: "Id", width: "80px"},
          {title: "Matricule", width: "150px"},
          {title: "Nom", width: "160px"},
          {title: "Prénom", width: "200px"},
          {title: "Brigade", width: "160px"},
          {
            title: "Date pointage",
            width: "180px",
            type: "date",
            dateFormat: "DD-MM-YYYY",
            correctFormat: true
          },
          {
            title: "Heure pointage",
            width: "180px",
            type: "time",
            timeFormat: "HH:mm:ss",
            correctFormat: true
          },
          {title: "Origine pointage", width: "160px"},
          {
            title: "Date création",
            width: "180px",
            dateFormat: "DD-MM-YYYY HH:mm:ss",
            correctFormat: true,
            type: "date",
            readOnly: true
          },
          {title: "Matricule créateur", width: "160px"}
        ],
        cells: function (row, col, prop) {
          const cellProperties = {};

          if (col === 0) {
            const cellValue = this.instance.getSourceDataAtCell(row, 13);
            if (cellValue === false) {
              cellProperties.renderer = cellRenderer;
            }
          }

          return cellProperties;
        }
      }
    }
  },
  computed: {
    FormIsValidS() {
      return (
          this.editedItem.userId !== "" &&
          this.editedItem.shiftName !== "" &&
          this.editedItem.startDate !== "" &&
          this.editedItem.startTime !== "" &&
          this.editedItem.endDate !== "" &&
          this.editedItem.endTime !== "" &&
          this.bDisplayCreerHSBtn === true
      );
    },

    FormIsValid() {
      return (
          this.editedItem.userId !== "" &&
          this.editedItem.shiftName !== "" &&
          this.editedItem.startDate !== "" &&
          this.editedItem.startTime !== "" &&
          this.editedItem.endDate !== "" &&
          this.editedItem.endTime !== ""
      );
    },

    computedDateFormatted1() {
      return this.formatDate(this.editedItem.startDate)
    },

    computedDateFormatted2() {
      return this.formatDate(this.editedItem.endDate)
    },

    computedDateFormatted11() {
      return this.formatTime(this.editedItem.startTime)
    },

    computedDateFormatted22() {
      return this.formatTime(this.editedItem.endTime)
    },
  },
  created() {
    this.depthDate()
    this.loadShifts()
  },
  mounted() {
    window.showPresence = this.showPresence;
    window.showHeuresSupp = this.showHeuresSupp;
    window.planning_presence = this.planning_presence;
    window.heures_supp = this.heures_supp;
  },
  methods: {
    planning_presence(row) {
      var data = this.$refs.hotTable.hotInstance.getData()[row];
      this.initdatetime();
      this.editedItem.firstName = data[3]
      this.editedItem.lastName = data[2]
      this.startDate = data[5]
      this.editedItem.userId = data[1];
      this.editedItem.id = data[0];
      this.isdisabled = true;
      this.pointage = "Pointage du " + this.startDate + " à " + data[6];
      this.showPresence();
    },
    heures_supp(row) {
      var data = this.$refs.hotTable.hotInstance.getData()[row];
      this.initdatetime();
      this.editedItem.firstName = data[3]
      this.editedItem.lastName = data[2]
      this.startDate = data[5]
      this.editedItem.userId = data[1];
      this.editedItem.id = data[0];
      this.isdisabled = true;
      this.pointageDay = this.startDate;
      this.pointageHour = data[6];
      this.pointage = "Pointage du " + this.startDate + " à " + data[6];
      this.showHeuresSupp();
    },
    cleared() {
      this.searchName = "";
      this.getData();
    },
    search() {
      var query = this.isEmpty(this.searchName) ? this.searchName : this.searchName.toLowerCase()

      if (this.isEmpty(query)) {
        this.cleared()
      }

      var row;
      var col;
      var rLen;
      var cLen;
      var data = this.$refs.hotTable.hotInstance.getData();
      var array = [];
      for (row = 0, rLen = data.length; row < rLen; row++) {
        for (col = 1, cLen = Object.keys(data[row]).length; col < cLen; col++) {
          var x = Object.keys(data[row])[col];
          if (('' + data[row][x]).toLowerCase().indexOf(query) > -1) {
            array.push(data[row]);
            break;
          }
        }
      }
      this.$refs.hotTable.hotInstance.loadData(array);
    },
    afterSelectionEnd(r, c) {
      var i;
      if (this.lastHighlitedRow !== null) {
        for (i = 0; i < this.$refs.hotTable.hotInstance.countCols(); i++) {
          this.$refs.hotTable.hotInstance.setCellMeta(this.lastHighlitedRow, i, 'className', 'htCenter htMiddle');
        }
      }

      for (i = 0; i < this.$refs.hotTable.hotInstance.countCols(); i++) {
        this.$refs.hotTable.hotInstance.setCellMeta(r, i, 'className', 'area highlight, htCenter htMiddle');
      }
      this.lastHighlitedRow = r;

      this.$refs.hotTable.hotInstance.render()
    },
    allowedDates(val) {
      var oneDayInMilliseconds = 86400000;
      let day, month, year;
      let dayR, monthR, yearR;

      dayR = this.getDay(val)
      monthR = this.getMonth(val)
      yearR = this.getYear(val)

      let refDate = new Date(yearR, monthR - 1, dayR)
      day = this.getDayFr(this.startDate)
      month = this.getMonthFr(this.startDate)
      year = this.getYearFr(this.startDate)

      let today = new Date(year, month - 1, day)
      let tomorrow = new Date(today.getTime() + oneDayInMilliseconds)
      let yesterday = new Date(today.getTime() - oneDayInMilliseconds)

      return (today.getTime() === refDate.getTime()) || (tomorrow.getTime() === refDate.getTime()) || (yesterday.getTime() === refDate.getTime());
    },

    functionEvents(date) {
      var oneDayInMilliseconds = 86400000;
      let day, month, year;
      let dayR, monthR, yearR;

      dayR = this.getDay(date)
      monthR = this.getMonth(date)
      yearR = this.getYear(date)

      let refDate = new Date(yearR, monthR - 1, dayR)

      day = this.getDayFr(this.startDate)
      month = this.getMonthFr(this.startDate)
      year = this.getYearFr(this.startDate)

      let today = new Date(year, month - 1, day)
      let tomorrow = new Date(today.getTime() + oneDayInMilliseconds)
      let yesterday = new Date(today.getTime() - oneDayInMilliseconds)

      if ((today.getTime() === refDate.getTime()) || (tomorrow.getTime() === refDate.getTime()) || (yesterday.getTime() === refDate.getTime())) {
        return ['red', '#00f']
      } else {
        return false
      }
    },
    initdatetime() {
      this.editedItem.firstName = "";
      this.editedItem.lastName = "";
      this.editedItem.shiftName = "";
      this.editedItem.startDate = "";
      this.editedItem.startTime = "";
      this.editedItem.endDate = "";
      this.editedItem.endTime = "";
      this.editedItem.presenceObservations = "";
      this.editedItem.userId = "";
      this.heuresSup = "";
      this.pointageDay = "";
      this.pointageHour = "";
      this.bDisplayCreerHSBtn = false;
    },
    loadShifts() {
      apiClient
          .get(
              `${this.$store.getters.user.baseUrl}/account/shifts/` + sessionStorage.getItem("userId")
          )
          .then(response => {
            sessionStorage.setItem("Shifts", null)
            let datas = response.data.datas;
            this.shiftsFull = datas;
            this.shifts = []
            datas.forEach(item => {
              this.shifts.push(item.shiftName);
            });
            sessionStorage.setItem("Shifts", JSON.stringify(this.shifts))
          })
          .catch(() => {
          });
    },
    loadDateTimeShift() {
      this.heuresSup = ""
      this.dismissible_closeS()
      this.bDisplayCreerHSBtn = false
      this.editedItem.startDate = "";
      this.editedItem.endDate = "";

      apiClient
          .get(
              `${this.$store.getters.user.baseUrl}/account/shifts/` + sessionStorage.getItem("userId")
          )
          .then(response => {
            let datas = response.data.datas;
            this.shifts = [];
            this.shiftsFull = datas;
            datas.forEach(item => {
              this.shifts.push(item.shiftName);
              if (item.shiftName === this.editedItem.shiftName) {
                this.editedItem.startTime = item["startTime"];
                this.editedItem.endTime = item["endTime"];
              }
            });

            this.isdisabled = false;
          })
          .catch(() => {
            this.isdisabled = true;
          });
    },
    getStartTimeShift(shiftName) {
      let result = "";
      this.shiftsFull.forEach(item => {
        if (item.shiftName === shiftName) {
          result = item.startTime;
        }
      });

      return result;
    },
    getEndTimeShift(shiftName) {
      let result = "";
      this.shiftsFull.forEach(item => {
        if (item.shiftName === shiftName) {
          result = item.endTime;
        }
      });

      return result;
    },
    loadEndDateShift(val) {
      //https://www.npmjs.com/package/dateformat
      this.heuresSup = ""
      this.bDisplayCreerHSBtn = false
      this.dismissible_closeS()
      let stimeS = this.editedItem.startTime
      stimeS = stimeS.split(':');
      let sectimeS = parseInt(stimeS[0] * 3600 + stimeS[1] * 60 + stimeS[0]);

      let stimeE = this.editedItem.endTime
      stimeE = stimeE.split(':');
      let sectimeE = parseInt(stimeE[0] * 3600 + stimeE[1] * 60 + stimeE[0]);

      if (sectimeS <= sectimeE) {
        this.editedItem.endDate = this.editedItem.startDate
      } else {
        var dateFormat = require('dateformat');
        let day, month, year;
        day = this.getDay(this.editedItem.startDate)
        month = this.getMonth(this.editedItem.startDate)
        year = this.getYear(this.editedItem.startDate)

        let sDatetimeS = new Date(year, month - 1, day)
        var oneDayInMilliseconds = 86400000;
        let sDatetimeE = new Date(sDatetimeS.getTime() + oneDayInMilliseconds)
        //this.editedItem.endDate = dateFormat(sDatetimeE, "yyyy-mm-dd");
        this.editedItem.endDate = moment(sDatetimeE).format("YYYY-MM-DD")
      }

      if (val === true) { // Calcul heures SUP
        var hour13InMilliseconds = 46800000;

        let day, month, year, dayHS, monthHS, yearHS, hour, min, sec, hourHS, minHS, secHS;
        day = this.getDay(this.editedItem.endDate)
        month = this.getMonth(this.editedItem.endDate)
        year = this.getYear(this.editedItem.endDate)

        dayHS = this.getDayFr(this.pointageDay)
        monthHS = this.getMonthFr(this.pointageDay)
        yearHS = this.getYearFr(this.pointageDay)

        hour = this.getHour(this.editedItem.endTime)
        min = this.getMin(this.editedItem.endTime)
        sec = this.getSec(this.editedItem.endTime)

        hourHS = this.getHour(this.pointageHour)
        minHS = this.getMin(this.pointageHour)
        secHS = this.getSec(this.pointageHour)

        let datetimefullend = new Date(year, month - 1, day, hour, min, sec)
        let datetimefullHS = new Date(yearHS, monthHS - 1, dayHS, hourHS, minHS, secHS)

        let diffDate = datetimefullHS.getTime() - datetimefullend.getTime()
        if ((diffDate < 0) || (diffDate > hour13InMilliseconds)) {
          this.colorS = "#F44336"
          this.alertS = true
          if (diffDate < 0) {
            this.textS = 'La date de pointage ne pas être inférieure à la date de fin de shift';
          } else {
            this.textS = 'Les Heures Sup ne peuvent être supérieures à 13h';
          }

          this.showAlertS('warning')
          return
        }

        this.bDisplayCreerHSBtn = true
        this.heuresSup = "Heures Supplémentaires estimées à " + this.convertMS(diffDate);
      }

    },
    convertMS(ms) {
      var d, h, m, s;
      s = Math.floor(ms / 1000);
      m = Math.floor(s / 60);
      s = s % 60;
      h = Math.floor(m / 60);
      m = m % 60;
      d = Math.floor(h / 24);
      h = h % 24;
      h += d * 24;
      return (h < 10 ? "0" + h : h) + ":" + (m < 10 ? "0" + m : m) + ":" + (s < 10 ? "0" + s : s);
    },
    getDay(date) {
      if (!date) return null

      const [year, month, day] = date.split('-')
      return `${day}`
    },
    getDayFr(date) {
      if (!date) return null

      const [day, month, year] = date.split('-')
      return `${day}`
    },
    getMonth(date) {
      if (!date) return null

      const [year, month, day] = date.split('-')
      return `${month}`
    },
    getMonthFr(date) {
      if (!date) return null

      const [day, month, year] = date.split('-')
      return `${month}`
    },
    getYear(date) {
      if (!date) return null

      const [year, month, day] = date.split('-')
      return `${year}`
    },
    getYearFr(date) {
      if (!date) return null

      const [day, month, year] = date.split('-')
      return `${year}`
    },
    getHour(time) {
      if (!time) return null

      const [hh, mm, ss] = time.split(':')
      return `${hh}`
    },
    getMin(time) {
      if (!time) return null

      const [hh, mm, ss] = time.split(':')
      return `${mm}`
    },
    getSec(time) {
      if (!time) return null

      const [hh, mm, ss] = time.split(':')
      return `${ss}`
    },
    formatDate(date) {
      if (!date) return null

      const [year, month, day] = date.split('-')
      return `${day}/${month}/${year}`
    },
    formatTime(time) {
      if (!time) return null

      const [hh, mm, ss] = time.split(':')
      return `${hh}:${mm}:${ss}`
    },
    showPresence() {
      this.$modal.show('modal-fade-planing-presence');
    },
    hidePresence() {
      this.initdatetime()
      this.$modal.hide('modal-fade-planing-presence');
    },
    showHeuresSupp() {
      this.$modal.show('modal-fade-heures-supp');
    },
    hideHeuresSupp() {
      this.heuresSup = ""
      this.bDisplayCreerHSBtn = false
      this.initdatetime()
      this.dismissible_closeS()
      this.$modal.hide('modal-fade-heures-supp');
    },
    AlertColor(type) {
      return type === "info" ? "#4CAF50" : "#F44336";
    },
    showAlert(type) {
      this.type = type

      let timer = this.showAlert.timer
      if (timer) {
        clearTimeout(timer)
      }
      this.showAlert.timer = setTimeout(() => {
        if (this.type === "info") {
          this.hidePresence()
        }
        this.type = null
      }, 20000)

      this.elapse = 1
      let t = this.showAlert.t
      if (t) {
        clearInterval(t)
      }

      this.showAlert.t = setInterval(() => {
        if (this.elapse === 4) {
          this.elapse = 0
          clearInterval(this.showAlert.t)
        } else {
          this.elapse++
        }
      }, 5000)
    },
    AlertColorS(typeS) {
      return typeS === "info" ? "#4CAF50" : "#F44336";
    },
    showAlertS(typeS) {
      this.typeS = typeS

      let timer = this.showAlertS.timer
      if (timer) {
        clearTimeout(timer)
      }
      this.showAlertS.timer = setTimeout(() => {
        this.typeS = null
      }, 20000)

      this.elapseS = 1
      let t = this.showAlertS.t
      if (t) {
        clearInterval(t)
      }

      this.showAlertS.t = setInterval(() => {
        if (this.elapseS === 4) {
          this.elapseS = 0
          clearInterval(this.showAlertS.t)
        } else {
          this.elapseS++
        }
      }, 5000)
    },
    dismissible_close() {
      this.elapse = 3
      clearTimeout(this.showAlert.timer)
      clearInterval(this.showAlert.t)
      this.type = null
    },
    dismissible_closeS() {
      this.elapseS = 3
      clearTimeout(this.showAlertS.timer)
      clearInterval(this.showAlertS.t)
      this.typeS = null
      this.closeAlertS()
    },
    closeAlert() {
      this.alert = false
      this.text = ""
      this.errors = []
    },
    closeAlertS() {
      this.alertS = false
      this.textS = ""
      this.errorsS = []
    },
    creer() {
      this.loading = true

      const dataToSave = {
        idTT: this.editedItem.id,
        userId: this.editedItem.userId,
        shiftName: this.editedItem.shiftName,
        startDate: moment(this.editedItem.startDate).format("YYYY-MM-DD HH:mm:ss"),
        startTime: moment(this.editedItem.startTime, "HH:mm:ss").format("YYYY-MM-DD HH:mm:ss"),
        endDate: moment(this.editedItem.endDate).format("YYYY-MM-DD HH:mm:ss"),
        endTime: moment(this.editedItem.endTime, "HH:mm:ss").format("YYYY-MM-DD HH:mm:ss"),
        presenceObservations: this.editedItem.presenceObservations,
        fromPresNotPlanned: true
      };
      apiClient
          .post(`${this.$store.getters.user.baseUrl}/account/presence/` + sessionStorage.getItem("userId"),
              dataToSave
          )
          .then(res => {
            this.dialog = false;
            this.loading = false
            if (res.data.status === 200) {
              this.hidePresence()
              this.color = "#009688"
              this.text = res.data.message
              this.initdatetime()
              this.showAlert('info')
              this.depthDate();
            } else {
              this.colorS = "#F44336"
              this.alertS = true
              this.textS = res.data.message;

              if (res.data.status === 425) {
                this.shifts = []
                this.shiftsFull = []

                let newObj = res.data.datas;
                newObj.forEach((item) => {
                  var array = item.split("%%")
                  this.shiftsFull.push(array[0])
                  this.shifts.push(array[1])
                })
              }

              this.showAlertS('warning')
            }
          })
          .catch(error => {
            this.alertS = true
            this.textS = error;
            this.loading = false
            this.colorS = "#F44336"
            this.showAlertS('warning')
          });
    },
    creerHS() {
      this.loading = true

      let sdatetimefullstart = moment(this.editedItem.endDate + " " + this.editedItem.endTime)
      let sdatetimefullend = moment(this.pointageDay + " " + this.pointageHour, "DD-MM-YYYY HH:mm:ss").format("YYYY-MM-DD HH:mm:ss")

      var oneDayInMilliseconds = 86400000;
      let days, months, years, daye, monthe, yeare, dayr, monthr, yearr;
      let hours, mins, secs, houre, mine, sece;

      days = this.getDay(moment(sdatetimefullstart).format("YYYY-MM-DD"))
      months = this.getMonth(moment(sdatetimefullstart).format("YYYY-MM-DD"))
      years = this.getYear(moment(sdatetimefullstart).format("YYYY-MM-DD"))

      daye = this.getDay(moment(sdatetimefullend).format("YYYY-MM-DD"))
      monthe = this.getMonth(moment(sdatetimefullend).format("YYYY-MM-DD"))
      yeare = this.getYear(moment(sdatetimefullend).format("YYYY-MM-DD"))

      if (!this.isEmpty(this.editedItem.startDate) && (this.editedItem.startDate !== null)) {
        dayr = this.getDay(moment(this.editedItem.startDate).format("YYYY-MM-DD"))
        monthr = this.getMonth(moment(this.editedItem.startDate).format("YYYY-MM-DD"))
        yearr = this.getYear(moment(this.editedItem.startDate).format("YYYY-MM-DD"))
      }

      hours = this.getHour(moment(sdatetimefullstart).format("HH:mm:ss"))
      mins = this.getMin(moment(sdatetimefullstart).format("HH:mm:ss"))
      secs = this.getSec(moment(sdatetimefullstart).format("HH:mm:ss"))

      houre = this.getHour(moment(sdatetimefullend).format("HH:mm:ss"))
      mine = this.getMin(moment(sdatetimefullend).format("HH:mm:ss"))
      sece = this.getSec(moment(sdatetimefullend).format("HH:mm:ss"))

      let datetimefullstart = new Date(years, months - 1, days, hours, mins, secs)
      let datetimefullend = new Date(yeare, monthe - 1, daye, houre, mine, sece)

      let datestart = new Date(years, months - 1, days)

      let dateShiftr = null, diffDateShiftR = null
      if (!this.isEmpty(this.editedItem.startDate) && (this.editedItem.startDate !== null)) {
        dateShiftr = new Date(yearr, monthr - 1, dayr)
        diffDateShiftR = Math.abs(dateShiftr.getTime() - datetimefullstart.getTime())
      }
      let diffDate = datetimefullend.getTime() - datetimefullstart.getTime()

      if ((sdatetimefullstart === "Invalid date") || (sdatetimefullend === "Invalid date") || (diffDate <= 0)
          || (diffDate >= oneDayInMilliseconds) || ((dateShiftr !== null) && (dateShiftr.getTime() > datestart.getTime()))) {
        if ((sdatetimefullstart === "Invalid date") || (sdatetimefullend === "Invalid date")) {
          this.textS = "Date invalide."
        } else if (diffDate <= 0) {
          this.textS = "La date de début est pas supérieure ou égale à la date de fin."
        } else if (diffDate >= oneDayInMilliseconds) {
          this.textS = "Les Heures Sup posées pour cet agent ne doivent pas dépasser 24h."
        } else {
          this.textS = "La date début Heures Sup ne peut pas être supérieure à la date du shift."
        }

        this.heuresSup = ""
        this.bDisplayCreerHSBtn = false
        this.colorS = "#F44336"
        this.alertS = true
        this.loading = false
        this.showAlertS('warning')
        return;
      }

      const dataToSave = {
        id: this.isEmpty(this.editedItem.id) ? 0 : this.editedItem.id,
        userId: this.editedItem.userId,
        dateShift: this.isEmpty(this.editedItem.startDate) ? null : moment(this.editedItem.startDate).format("YYYY-MM-DD HH:mm:ss"),
        nameShift: this.editedItem.shiftName,
        startDayHeuresSup: moment(sdatetimefullstart).format("YYYY-MM-DD HH:mm:ss"),
        startHourHeuresSup: moment(sdatetimefullstart).format("YYYY-MM-DD HH:mm:ss"),
        endDayHeuresSup: moment(sdatetimefullend).format("YYYY-MM-DD HH:mm:ss"),
        endHourHeuresSup: moment(sdatetimefullend).format("YYYY-MM-DD HH:mm:ss"),
        startFullDateHeuresSup: moment(sdatetimefullstart).format("YYYY-MM-DD HH:mm:ss"),
        endFullDateHeuresSup: moment(sdatetimefullend).format("YYYY-MM-DD HH:mm:ss"),
        observations: this.editedItem.presenceObservations
      };
      apiClient
          .post(`${this.$store.getters.user.baseUrl}/account/heuressup/true` + "/" + sessionStorage.getItem("userId"),
              dataToSave
          )
          .then(res => {
            this.loading = false
            if (res.data.status === 200) {
              this.color = "#009688"
              this.text = res.data.message
              this.alert = true
              this.showAlert('info')
              this.hideHeuresSupp()
              this.refresh()
            } else {
              this.colorS = "#F44336"
              this.alertS = true
              this.textS = res.data.message;
              this.showAlertS('warning')
            }
          })
          .catch(error => {
            this.alertS = true
            this.textS = error;
            this.loading = false
            this.colorS = "#F44336"
            this.showAlertS('warning')
          });
    },
    depthDate() {
      if (this.depthVal) {
        sessionStorage.setItem("depthValChoosedd", this.depthVal.value)
        sessionStorage.setItem("depthValChoosedt", this.depthVal.name)
      }
      this.getData(this.depthVal)
    },
    isEmpty(str) {
      return (!str || 0 === str.length || /^\s*$/.test(str));
    },
    dynamicID() {
      return 'dynamicID-' + Math.floor(Math.random() * Date.now().toString());
    },
    getData(valeur) {
      this.loading = true
      valeur = this.depthVal.value
      apiClient
          .get(`${this.$store.getters.user.baseUrl}/reports/presencesnotpredictedreportbydatedepth/` + moment().subtract(valeur, "days").format("YYYY-MM-DD") + "/" + sessionStorage.getItem("userId"))
          .then(response => {
            this.loading = false
            let tabArray = []
            let newObj = response.data.datas;

            if (response.data.status !== 200) {
              this.color = "#009688"
              this.text = response.data.message;
              this.showAlert('warning')
              this.disableMainBtn = true
            } else {
              this.disableMainBtn = false
            }

            String.prototype.capitalize = function (allWords) {
              return (allWords) ? // if all words
                  this.split(' ').map(word => word.capitalize()).join(' ') : //break down phrase to words then  recursive calls until capitalizing all words
                  this.charAt(0).toUpperCase() + this.slice(1); // if allWords is undefined , capitalize only the first word , mean the first char of the whole string
            }

            newObj.forEach((item) => {
              tabArray.push([
                item["id"],
                item["userId"],
                this.isEmpty(item["accountLastname"]) ? "" : item["accountLastname"].toUpperCase(),
                this.isEmpty(item["accountFirstname"]) ? "" : item["accountFirstname"].toLowerCase().capitalize(true),
                this.isEmpty(item["brigade"]) ? "" : item["brigade"].toUpperCase(),
                moment(item["day"], 'YYYY-MM-DD').format('DD-MM-YYYY'),
                moment(item["time"]).format("HH:mm:ss"),
                item["typeRecord"],
                item["creationDate"] !== null ? moment(item["creationDate"]).format("DD-MM-YYYY HH:mm:ss") : "",
                item["originUser"]
              ])
            })

            this.$refs.hotTable.hotInstance.loadData(tabArray)
            this.toObject = [this.hotSettings.colHeaders, ...this.$refs.hotTable.hotInstance.getData()];
            this.toObjectNoHeader = this.$refs.hotTable.hotInstance.getData();
            this.$refs.hotTable.hotInstance.render()
          })

          .catch(() => {
            this.loading = false
          });
    },
    onCancel() {
      this.loading = false
    },
    refresh() {
      this.getData(this.depthVal)
    },
    afterLoadData() {
      this.toObject = [this.hotSettings.colHeaders, ...this.$refs.hotTable.hotInstance.getData()];
      this.toObjectNoHeader = this.$refs.hotTable.hotInstance.getData();
    },
    afterFilter() {
      this.toObject = [this.hotSettings.colHeaders, ...this.$refs.hotTable.hotInstance.getData()];
      this.toObjectNoHeader = this.$refs.hotTable.hotInstance.getData();
    },

    onexport() { // On Click Excel download button
      // export json to Worksheet of Excel
      // only array possible
      this.loading = true
      var datas = XLSX.utils.json_to_sheet(this.toObject, {skipHeader: true})
      // var pokemonWS = XLSX.utils.json_to_sheet(this.Datas.pokemons)

      // A workbook is the name given to an Excel file
      var wb = XLSX.utils.book_new() // make Workbook of Excel

      // add Worksheet to Workbook
      // Workbook contains one or more worksheets
      XLSX.utils.book_append_sheet(wb, datas, "Présences_non_prévues") // sheetAName is name of Worksheet
      // XLSX.utils.book_append_sheet(wb, pokemonWS, "pokemons")

      // export Excel file
      XLSX.writeFile(wb, "Présences_non_prévues.xlsx") // name of the file is "book.xlsx"
      this.loading = false
    }
  }
};
</script>

<style scoped>
.toolbar .v-toolbar__content {
  padding: 0 !important
}

.input-class {
  padding: 2px 0;
  border-bottom: solid 1px #999;
  color: #444;
  width: 100%;
}

.v-text-field {
  min-width: 222px;
}

.custom-btn {
  width: 222px;
}

.custom-btn::before {
  color: transparent
}

.custom-btn:hover {
  color: #F5F5F5 !important;
}
</style>